"use client";

import React, { useEffect, useState } from "react";
import { isConsentGiven } from "./cookieConsent"; // Adjust the path based on your file structure

const CookieOverlay: React.FC = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      if (!isConsentGiven()) {
        setShowOverlay(true); // Show overlay if consent is not given
      } else {
        setShowOverlay(false); // Hide overlay if consent is given
      }
    };

    // Initial check for consent
    checkConsent();

    // Poll every second to check for consent status changes
    const interval = setInterval(() => {
      checkConsent();
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  if (!showOverlay) return null; // Do not render if consent is given

  return (
    <div
      id="cookie-blocker-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: "18px",
      }}
    >
      <p>Please provide cookie consent to continue browsing.</p>
    </div>
  );
};

export default CookieOverlay;
